import { render, staticRenderFns } from "./ConferenceRoomScreen.vue?vue&type=template&id=b38fa4b0&scoped=true"
import script from "./ConferenceRoomScreen.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomScreen.vue?vue&type=script&lang=js"
import style0 from "./ConferenceRoomScreen.vue?vue&type=style&index=0&id=b38fa4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38fa4b0",
  null
  
)

export default component.exports